<div class="input-group">
	<ng-content></ng-content>
	<div class="input-group-append">
		<button class="btn btn-primary btn-icon btn-icon" type="button" title="{{ 'Actions.Add' | translate }}"
			[disabled]="disabled" [matMenuTriggerFor]="addMenu">
			<i class="fas fa-plus"></i>
		</button>

		<mat-menu #addMenu="matMenu" class="dropdown-menu dropdown-menu-alt dropdown-menu-right">
			<ng-template [ngTemplateOutlet]="dropdownContent"></ng-template>
		</mat-menu>
	</div>
</div>